<script setup lang="ts">
/**
 * Haut de /collecte-dons-association, charte « apple » (Karim 2026-10-18) :
 * textes inchangés, mise en page commune HeroSceneApple (vraie page de don
 * sur ordinateur, accueil de l'appli sur téléphone).
 */
const { t } = useI18n({ useScope: "local" });
const localePath = useLocalePath();
</script>

<template>
  <HeroSceneApple
    :surtitre="t('breadcrumb.collecte')"
    :description="t('hero.description')"
    :cta="t('cta.organiser')"
    cta-source="hero"
    :lien-texte="t('cta.comparer')"
    :lien-href="localePath({ path: '/comparateurs/dons-en-ligne' })"
    :garanties="[t('reassurance.commission'), t('reassurance.gratuit'), t('reassurance.fonds')]"
    image-telephone="/billetterie/app-home.webp"
    :alt-ordinateur="t('alt.pageDon')"
    :alt-telephone="t('alt.appMobile')"
  >
    <template #titre>
      <i18n-t keypath="hero.titre" tag="span" scope="parent">
        <template #mot>
          <span class="text-(--color-main)">{{ t("hero.mot") }}</span>
        </template>
      </i18n-t>
    </template>
  </HeroSceneApple>
</template>

<i18n lang="json" src="../../../i18n/pages/components/collecte-page/CollecteHero.json"></i18n>
